import { year } from "../../misc/helpers";

var configoverride = {};

/****************************************************************************************************/
// APPLICATION MODE
/****************************************************************************************************/
configoverride.mode = {
  anonymous_enabled: false, //Anonymous login enabled
  anonymous_autologin: false, //Login as anonymous automatically
  authenticated_enabled: true, //Authenticated login enabled
  services_enabled: true, //Services tab visible
  contacts_enabled: true, //Contacts tab visible
  call_enabled: true, //Call tab visible
  history_enabled: false, //History tab visible
  messages_enabled: true, //Message tab visible
  settings_enabled: true, //Settings tab visible
  display_settings_in_menu: true, //Display settings instead of account in menu
  logout_enabled: true, //Show logout button in topbar instead of in settings menu
  name_enabled: false, //Shows name in top right corner
  online_enabled: true, //Online symbol visible in
  home: "services", //Home page. Possible values: services, contacts, call, history, messages
  kiosk: false, //Kiosk mode
  kiosk_main_layout: false, //Use the "normal" layout in kiosk mode
  restrict: false, //Restrict Kiosk to only call registred numbers
  inIframe: false, //Can the page be displayed in an iFrame
  forceIframe: false, //Must the page be displayed in an iFrame
  registration_enabled: false, //Registration enabled
  resetpassword_enabled: false, //Reset password enabled
  changeuser_enabled: false, //Change user account enabled
  setting_text_enabled: true, //Enable change text on settings
  setting_text_visible_by_default: true, //Whether the text should be visible by default or not
  setting_ringtone_enabled: true, //Enable change ringtone in settings
  setting_media_enabled: true, //Enable change used media on settings
  setting_message_enabled: false, //Enable change message on settings
  text_in_footer: true, // Display Call with audio ON/OFF in footer
  use_double_audio_icons_in_footer: false, //Display both mic and speaker in footer
  buttons_in_footer: true, //Show media buttons in footer
  link_to_settings_in_footer: false, // Display link to media settings in footer
  debug_enabled: true, //Enable debug
  debug_enabled_in_menu: false, //Enable debug in menu
  register_with_userpart_from_sip: false, // Use the userpart from the SIP-address instead of username in register
  dialpad: true, //Enable or disable the in call dialpad
  audio: true, //Enable/disable audio
  video: true, //Enable/disable video
  safetext: true, //Enable/disable text
  opensips: true,
};

/*
configoverride.anonymous = {
  user: "anonymous",
  password: "xxxxx",
};
*/

configoverride.texts = {
  en: {
    "common.appOwner": "Tess",
    "common.appName": "Tess Web-App",
    "common.copyright": `© ${year} nWise. All Rights Reserved.`,
  },
  de: {
    "common.appOwner": "Tess",
    "common.appName": "Tess Web-App",
    "common.copyright": `© ${year} nWise. All Rights Reserved.`,
    "common.callback": "Zurückrufen",
    "common.callagain": "Erneut anrufen",
    "common.on": "Ein",
    "common.abort": "Abbrechen",
    "common.cancel": "Beenden",
    "common.save": "Speichern",
    "common.calling": "Anruf",
    "common.dialer": "Wählen",
    "common.username": "Benutzername",
    "about.user": "Benutzername",
    "titles.login": "Login",
    "login.headline": "Login",
    "login.login": "Login",
    "login.loginfailed": "Login fehlgeschlagen",
    "login.optinalLoginInfo": "WICHTIG: Bitte achten Sie bei der Anmeldung auf die Groß- und Kleinschreibung Ihrer Benutzerdaten!",
    "titles.services": "Dienste",
    "menu.services": "Dienste",
    "menu.servicesHeadline": "Dienste",
    "menu.contacts": "Telefonbuch",
    "menu.mycontacts": "meine Kontakte",
    "titles.settings": "Einstellungen",
    "menu.settings": "Einstellungen",
    "settings.settings": "Einstellungen",
    "titles.messages": "Nachrichten",
    "menu.messages": "Nachrichten",
    "messages.messages": "Nachrichten",
    "settings.mediamail": "Abwesenheit",
    "settings.autoanswer": "Aktiviere Abwesenheitsnachricht",
    "settings.about": "Über",
    "settings.audio": "Audio",
    "settings.useaudio": "Rufen Sie mit Audio an",
    "menu.history": "Historie",
    "history.history": "Historie",
    "toolbar.hidetext": "Text ist ausgeschaltet",
    "toolbar.useaudioon": "Anruf mit Audio ist eingeschaltet",
    "toolbar.useaudiooff": "Anruf mit Audio ist ausgeschaltet",
    "toolbar.usevideooff": "Anruf mit Video ist ausgeschaltet",
    "toolbar.usetextoff": "Anruf mit Text ist ausgeschaltet",
    "toolbar.micoff": "Mikrofon ist aus",
    "toolbar.micon": "Mikrofon ist an",
    "toolbar.audiooff": "Audio ist aus",
    "toolbar.audioon": "Audio ist an",
    "toolbar.cameraoff": "Mein Video ist aus",
    "toolbar.cameraon": "Mein Video ist an",
    "about.version": "Version",
    "about.os": "Betriebssystem",
    "login.logo.href": "https://www.tess-relay-dienste.de/",
    "error.cantcall_without_media": "Ohne Audio, Video oder Text können Sie keine Anrufe tätigen",
    "aria.link_sound_video": "Gehen Sie zu den Einstellungen für Audio und Video",
  },
};

export default configoverride;






// WEBPACK FOOTER //
// ./src/branding/current/configoverride.js